import en from './en';

export default { en } as { en: typeof en };
